import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    const session_id = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        // Also store as bearer for API calls (session_token doubles as bearer)
        localStorage.setItem("srl_token", data.session_token);
        setUser(data.user);
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard", { state: { user: data.user } });
      } catch {
        nav("/login");
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center">
      <div className="overline">Authorising…</div>
    </div>
  );
}
